(ns dashboard.services.questionnaires
  (:require [dashboard.components.file-preview :as file-preview]
            [dashboard.services.http-config :as http-config]
            [dashboard.utils :as utils]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]))

;; Subs

(rf/reg-sub
 ::questionnaires
 (fn [db]
   (:questionnaires db)))

(rf/reg-sub
 ::questionnaire
 :<- [::questionnaires]
 (fn [questionnaires [_ questionnaire-id]]
   (get questionnaires questionnaire-id)))

(rf/reg-sub
 ::questions
 (fn [[_ questionnaire-id]]
   (rf/subscribe [::questionnaire questionnaire-id]))
 (fn [questionnaire]
   (get-in questionnaire [:questions :data])))

(rf/reg-sub
 ::sections
 (fn [[_ questionnaire-id]]
   (rf/subscribe [::questionnaire questionnaire-id]))
 (fn [questionnaire]
   (get-in questionnaire [:sections :data])))

(rf/reg-sub
 ::question-status-frequencies
 (fn [[_ questionnaire-id]]
   (rf/subscribe [::questions questionnaire-id]))
 (fn [questions]
   [(frequencies (map (fn [q]
                        (if (-> q
                                :answer-scope
                                :content
                                (utils/str-includes-icase? "out of scope"))
                          "out-of-scope"
                          (:status q)))
                      questions))
    (count questions)]))

(rf/reg-sub
 ::metadata
 (fn [[_ questionnaire-id]]
   (rf/subscribe [::questionnaire questionnaire-id]))
 (fn [questionnaire]
   (get-in questionnaire [:metadata :data])))

;; Events

(rf/reg-event-fx
 ::fetch-file-preview-url
 (fn [_ [_ filename]]
   (let [download-url (str "/api/questionnaires/files/" (js/encodeURIComponent filename))]
     {:http-xhrio {:method          :get
                   :uri             (str download-url "/url")
                   :timeout         http-config/timeout
                   :response-format http-config/transit-response-format
                   :on-success      [::file-preview/show-file-preview download-url filename]
                   :on-failure      [::ui/set-error "Could not get questionnaire file URL"]}})))
